import * as React from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import type { InjectedFormProps } from 'redux-form';

import MaterialMarkupsAdjustmentModal from 'af-root/scenes/Company/Shared/Materials/MaterialMarkupsAdjustmentModal';

import { MATERIAL_JOB_MARKUP_UPSERT } from 'af-constants/reduxForms';

import * as MaterialJobMarkupHistoryActions from 'af-actions/materialJobMarkupHistory';

import MaterialJobMarkupFM from './formModel';

interface OwnProps {
	jobId: number;
	initialValues: Nullable<Partial<MaterialJobMarkupFM>>;
	showModal: boolean;
	onSubmitSuccess: () => void;
	close: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector> & InjectedFormProps<MaterialJobMarkupFM>;

const MaterialJobMarkupAdjustmentModal: React.FC<Props> = (props) => {
	const { jobId, close, handleSubmit, showModal, upsert, onSubmitSuccess: onSubmit, initialize, initialValues, valid } = props;

	React.useEffect(() => {
		if (showModal) {
			initialize(new MaterialJobMarkupFM(initialValues ?? undefined));
		}
	}, [initialValues, initialize, showModal]);

	const upsertMaterialCompanyMarkup = React.useCallback(async (form: MaterialJobMarkupFM) => {
		await upsert(jobId, MaterialJobMarkupFM.toRM(form));
		onSubmit();
		close();
	}, [close, jobId, onSubmit, upsert]);

	const formUpsert = React.useMemo(() => handleSubmit(upsertMaterialCompanyMarkup), [handleSubmit, upsertMaterialCompanyMarkup]);

	const handleFormSubmit = React.useCallback(() => {
		formUpsert();
	}, [formUpsert]);

	return (
		<MaterialMarkupsAdjustmentModal
			close={close}
			level="Job"
			onSubmit={handleFormSubmit}
			showModal={showModal}
			submitDisabled={!valid}
		/>
	);
};

function mapDispatchToProps() {
	return {
		upsert: MaterialJobMarkupHistoryActions.upsert,
	};
}

const connector = connect(null, mapDispatchToProps());

const formConnector = reduxForm({
	form: MATERIAL_JOB_MARKUP_UPSERT,
	validate: MaterialJobMarkupFM.validate,
});

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector,
	formConnector
);

export default enhance(MaterialJobMarkupAdjustmentModal);
